<template>
    <div>
        <v-card v-for="(order, i) in bulkOrder.orders" :key="i" outlined class="mb-3">
            <v-card-title class="pb-0">
                {{ $t('orders.order_no', {n: i + 1}) }}
            </v-card-title>
            <v-card-text>
                <order-detail :order="order" hide-approve-button hide-edit-button/>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import OrderDetail from "@/components/user/orders/OrderDetail";

export default {
    name: "BulkOrderDetail",
    components: {OrderDetail},
    props: {
        bulkOrder: {
            type: Object,
            required: true
        }
    }
}
</script>
